module.exports = __webpack_public_path__ + "img/promotions-highroller.a80aa81c.png";